import React, { useRef } from 'react';
import { createUseStyles } from 'react-jss';
import AceEditor from 'react-ace';

// Import ace modes and theme
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-tomorrow_night';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/ext-searchbox';
// Bundle the snippets enabled below; otherwise ace fetches them from a relative URL
// that the app answers with index.html.
import 'ace-builds/src-noconflict/snippets/html';
import 'ace-builds/src-noconflict/snippets/css';
import 'ace-builds/src-noconflict/snippets/javascript';

const useStyles = createUseStyles({
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  editor: {
    width: '100%',
    flex: 1,
    minHeight: '300px',
  },
  readOnlyOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    padding: '8px 16px',
    background: 'rgba(251, 191, 36, 0.9)',
    color: '#78350f',
    fontSize: '12px',
    fontWeight: 500,
    zIndex: 10,
    textAlign: 'center',
  },
});

interface Props {
  language: 'html' | 'css' | 'js';
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  readOnlyMessage?: string;
}

const modeMap = {
  html: 'html',
  css: 'css',
  js: 'javascript',
};

const CodeEditor: React.FC<Props> = ({ language, value, onChange, readOnly = false, readOnlyMessage }) => {
  const c = useStyles();
  const editorRef = useRef<any>(null);

  return (
    <div className={c.container}>
      {readOnly && (
        <div className={c.readOnlyOverlay}>
          {readOnlyMessage || 'Read-only mode'}
        </div>
      )}
      <AceEditor
        ref={editorRef}
        mode={modeMap[language]}
        theme="tomorrow_night"
        value={value}
        onChange={onChange}
        name={`code-editor-${language}`}
        className={c.editor}
        width="100%"
        height="calc(100vh - 200px)"
        fontSize={14}
        showPrintMargin={false}
        showGutter={true}
        highlightActiveLine={true}
        readOnly={readOnly}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
          useWorker: false,
        }}
        editorProps={{ $blockScrolling: true }}
      />
    </div>
  );
};

export default CodeEditor;

